import gql from "graphql-tag";

// Todo - make use of this query, will give a performance boast
export const SUPPORTED_PREFERENCES_QUERY = gql`
    query SupportedPreferences {
        user {
            supportedPreferences {
                currencies {
                    id
                    name
                    subtext
                    value
                }
                cultures {
                    id
                    name
                    subtext
                    value
                }
                benchmarkCultures {
                    id
                    name
                    subtext
                    value
                }
            }
        }
    }
`;
